import {$data} from '../../helpers/data';
import {$dom} from '../../helpers/dom';
import IMask from 'imask';
import is from 'is_js';

const {
	callAll,
	exist
} = $dom;

export default function phoneMask(fieldSelector = '.js-phone-field', maskOptions = {}) {

	if (exist(fieldSelector)) {
		const
			defaults = {
				mask: '+{7} (000) 000-00-00'
			},
			opts = $data.merge(maskOptions, defaults),
			init = () => callAll(fieldSelector, f => f.IMask = IMask(f, opts)),
			destroy = () => {
				callAll(fieldSelector, f => {
					if (is.not.undefined(f.IMask)) f.IMask.destroy();
				});
			}
		;
		return {init, destroy}
	}
	return null;
}
